<template>
  <!-- 生成されたBookGroupのデータが入ったら描画される -->
  <TemplateBookBookingResult v-if="isPaymentDone" :isPaymentError="isPaymentError"/>

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :onClose="backToPreviousPage" />

  <DialogIssueExternalCouponSuccess
    ref="DialogIssueExternalCouponSuccess"
    :openCouponVersionWarning="openCouponVersionWarning"
    :isNotTargetVersion="isNotTargetVersion"
  />
  <DialogIssueExternalCouponFail
    ref="DialogIssueExternalCouponFail"
    :retry="retryIssuedExternalCoupon"
  />
  <DialogCouponVersionWarning ref="DialogCouponVersionWarning" />
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import TemplateBookBookingResult from "@/views/Templates/TicketStore/TemplateBookBookingResult";

// API
import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";
import bookGroupService from "@/services/bookGroup";

export default {
  name: "BookBookingResult",
  components: {
    TemplateBookBookingResult: TemplateBookBookingResult,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const paymentProcessInfo = computed(
      () => store.getters["ticketing/paymentProcessInfo"]
    );

    const isPaymentDone = ref(false);
    const isPaymentError = ref(false);

    const DialogIssueExternalCouponSuccess = ref(null);
    const DialogIssueExternalCouponFail = ref(null);
    const DialogCouponVersionWarning = ref(null);

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);


    const divisionCalTotalPrice = computed(() =>
      bookGroupService.calTotal(bookGroup.value)
    );


    const isNotTargetVersion = ref(false);

    // タイムアウトした場合、前の画面に戻す
    const backToPreviousPage = () => {
      router.go(-1);
    };

    const setPaymentState = (state) => {
      isPaymentDone.value = true;
      isPaymentError.value = state;
    };

    onMounted(async () => {
      nativeHandlerService.ncAppVersion();
      if (route.query.voucher == "true") {
        //Show success result page for voucher (by using couponcode, qr-code)
        setPaymentState(false);
      } else {
        try {
          if (divisionCalTotalPrice.value == 0) {
            isPaymentDone.value = true;
            return;
          }
          //purchase success + mail_sent success
          //purchase success + mail_sent fail
          if (paymentProcessInfo.value.result == "success") {

            // nativeに情報送信(描画までの時間を短縮するため、描画後に実行)
            nativeHandlerService.ncBuyTicket(
              masterBook.value.id,
              bookGroup.value.id,
              book.value,
              masterBook.value.start_hour
            );

            //mail_sent:false -> error:true
            setPaymentState(!paymentProcessInfo.value.mail_sent);

            if (paymentProcessInfo.value.coupon_issued == true) {
              DialogIssueExternalCouponSuccess.value.openDialog(
                paymentProcessInfo.value.mail_sent
              );
            } else if (paymentProcessInfo.value.coupon_issued == false)  {
              DialogIssueExternalCouponFail.value.openDialog();
            }

            return;
          }
          
          //purchase error
          setPaymentState(true);
          
        } catch (err) {
          console.log("BookBookingResult :>> ", err);
          nativeHandlerService.ncSendTicketingError(
            "BookBookingResult onMounted()",
            JSON.stringify(err)
          );
        }
      }
    });

    const retryIssuedExternalCoupon = async () => {
      try {
        const numberCouponIssued = await API.retryIssuedExternalCoupon(
          masterBook.value.id,
          book.value.id,
          false
        );
        if (numberCouponIssued >= 0) {
          DialogIssueExternalCouponSuccess.value.openDialog(
            paymentProcessInfo.value.mail_sent
          );
        }
      } catch (err) {
        console.log("BookBookingResult :>> retry issue coupon fail");
        DialogIssueExternalCouponFail.value.openDialog();
      }
    };

    const openCouponVersionWarning = () => {
      DialogCouponVersionWarning.value.openDialog();
    };

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      let bool = false;
      switch (device.value) {
        case "IOS":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        case "ANDROID":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        default:
          bool = false;
          break;
      }
      isNotTargetVersion.value = bool;
    };

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      isPaymentDone,
      isPaymentError,
      backToPreviousPage,
      retryIssuedExternalCoupon,
      DialogIssueExternalCouponSuccess,
      DialogIssueExternalCouponFail,
      DialogCouponVersionWarning,
      openCouponVersionWarning,
      isNotTargetVersion,
    };
  },
};
</script>
